import IconWrapper, { IconWrapperProps } from '@repo/ui/src/components/IconWrapper';

const SupportIcon = (props: IconWrapperProps) => (
  <IconWrapper width="25" height="24" viewBox="0 0 25 24" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        d="M0 0H24V24H0z"
        transform="translate(-1131 -1807) translate(-.288 128) translate(1108.288 119) translate(0 1416) translate(23.045 24) translate(0 78) translate(0 40) translate(0 2)"
      />
      <path
        fill="#666869"
        d="M22 6h-2v9c0 .553-.447 1-1 1h-9v2h7c.266 0 .52.105.707.293L20 20.586V19c0-.553.447-1 1-1h1V6zm-4 8V2H2v12h1c.553 0 1 .447 1 1v1.586l2.293-2.293C6.48 14.105 6.734 14 7 14h11zm6-9v14c0 .553-.447 1-1 1h-1v3c0 .404-.243.77-.617.924-.124.052-.254.076-.383.076-.26 0-.516-.102-.707-.293L16.586 20H9c-.553 0-1-.447-1-1v-3h-.586l-3.707 3.707C3.516 19.898 3.26 20 3 20c-.129 0-.259-.024-.383-.076C2.243 19.77 2 19.404 2 19v-3H1c-.553 0-1-.447-1-1V1c0-.553.447-1 1-1h18c.553 0 1 .447 1 1v3h3c.553 0 1 .447 1 1zM14 7c-.553 0-1 .447-1 1 0 .553.447 1 1 1 .553 0 1-.447 1-1 0-.553-.447-1-1-1zm-4 0c-.553 0-1 .447-1 1 0 .553.447 1 1 1 .553 0 1-.447 1-1 0-.553-.447-1-1-1zM7 8c0 .553-.447 1-1 1-.553 0-1-.447-1-1 0-.553.447-1 1-1 .553 0 1 .447 1 1z"
        transform="translate(-1131 -1807) translate(-.288 128) translate(1108.288 119) translate(0 1416) translate(23.045 24) translate(0 78) translate(0 40) translate(0 2)"
      />
    </g>
  </IconWrapper>
);

export default SupportIcon;
